import React from "react"
import Emitter from "../../../helpers/emitter"
import * as EventSpace from "../../../constants/eventSpaces"
import * as Event from "../../../constants/emits"

const PdpButton = ({ textKeys, showButton }) => {
  const clickHandler = () => {
    Emitter.emit(Event.withEventSpace(EventSpace.PRODUCT_STOCK_OVERLAY, Event.OPEN_OVERLAY), true)
  }

  return showButton ? (
    <button onClick={clickHandler} className="cta grey show-stock-overlay" type="button">
      {textKeys.findInStoreButtonText}
    </button>
  ) : (
    <></>
  )
}

export default PdpButton
